export default "__VITE_ASSET__Bzjejv0C__"